import { Bot, Sparkles } from "lucide-react"

interface Props {
  title?: string
  description?: string
  size?: "sm" | "lg"
}

const AdvisorEmptyState = ({
  title = "No AI Advisor conversations yet",
  description = "When leads interact with the AI Advisor, their sessions will appear here.",
  size = "sm"
}: Props) => {
  const iconWrap = size === "lg" ? "w-16 h-16" : "w-14 h-14"
  const iconSize = size === "lg" ? "w-8 h-8" : "w-7 h-7"
  const sparkleSize =
    size === "lg" ? "w-7 h-7 -top-1.5 -left-1.5" : "w-6 h-6 -top-1 -left-1"
  const titleClass =
    size === "lg"
      ? "text-lg font-semibold text-neutral-700"
      : "text-sm font-semibold text-neutral-600"

  return (
    <div className="flex flex-col items-center justify-center gap-4 py-24 px-8 text-center">
      <div
        className={`relative ${iconWrap} flex items-center justify-center rounded-full bg-indigo-50`}
      >
        <Bot className={`${iconSize} text-indigo-300`} />
        <Sparkles className={`text-indigo-300 absolute ${sparkleSize}`} />
      </div>
      <p className={titleClass}>{title}</p>
      <p className="text-xs text-neutral-400 max-w-xs">{description}</p>
    </div>
  )
}

export default AdvisorEmptyState
